// Base skeleton component with shimmer animation
export const SkeletonBox = ({
  width,
  height,
  borderRadius = 4,
  style = {},
}) => (
  <div
    style={{
      width,
      height,
      background: "linear-gradient(90deg, #222 25%, #333 50%, #222 75%)",
      backgroundSize: "200% 100%",
      animation: "shimmer 1.5s infinite",
      borderRadius,
      paddingBottom: 12,
      ...style,
    }}
  >
    <SkeletonStyles />
  </div>
);

// Skeleton for chart/graph areas
export const SkeletonChart = ({
  height = 525,
  message = "Loading chart data...",
}) => (
  <div
    style={{
      width: "100%",
      height,
      background: "linear-gradient(90deg, #111 25%, #222 50%, #111 75%)",
      backgroundSize: "200% 100%",
      animation: "shimmer 1.5s infinite",
      borderRadius: 8,
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <SkeletonStyles />
    <div style={{ color: "#666", fontSize: 16 }}>🔄 {message}</div>
  </div>
);

// Skeleton for text lines with varying widths
export const SkeletonText = ({
  lines = 1,
  widths = ["100%"],
  height = 14,
  gap = 6,
}) => (
  <div
    style={{ display: "flex", flexDirection: "column", gap, paddingBottom: 12 }}
  >
    {Array.from({ length: lines }, (_, i) => (
      <SkeletonBox
        key={i}
        width={Array.isArray(widths) ? widths[i % widths.length] : widths}
        height={height}
      />
    ))}
  </div>
);

// Skeleton for button groups
export const SkeletonButtons = ({
  count = 2,
  buttonHeight = 40,
  buttonWidths,
}) => (
  <div style={{ display: "flex", gap: 16, width: "100%" }}>
    {Array.from({ length: count }, (_, i) => {
      const width = Array.isArray(buttonWidths)
        ? buttonWidths[i] || "100%"
        : buttonWidths || "100%";

      return (
        <SkeletonBox
          key={i}
          width={width}
          height={buttonHeight}
          borderRadius={8}
        />
      );
    })}
  </div>
);

// Skeleton for stats/metrics row
export const SkeletonStats = ({ count = 3 }) => (
  <div style={{ margin: "30px 0 10px", display: "flex", gap: 40 }}>
    {Array.from({ length: count }, (_, i) => (
      <SkeletonBox
        key={i}
        width={`${150 + Math.random() * 50}px`}
        height={20}
      />
    ))}
  </div>
);

// CSS Animation styles
export const SkeletonStyles = () => (
  <style>{`
    @keyframes shimmer {
      0% {
        background-position: -200% 0;
      }
      100% {
        background-position: 200% 0;
      }
    }
  `}</style>
);

export default {
  SkeletonBox,
  SkeletonChart,
  SkeletonText,
  SkeletonButtons,
  SkeletonStats,
  SkeletonStyles,
};
